import { AutherClient } from "@cadolabs/auther-client"

import config from "$config"

export default AutherClient.init({
  autherUrl: config.auther.url,
  redirectUri: config.auther.redirectUri,
  appcode: "unetsafe",
})
